import { render, staticRenderFns } from "./TeamTab.vue?vue&type=template&id=c2192f60&scoped=true&"
import script from "./TeamTab.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TeamTab.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TeamTab.vue?vue&type=style&index=0&id=c2192f60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2192f60",
  null
  
)

export default component.exports